module.exports = __webpack_public_path__ + "media/svg-new/icon-linguagens-752aa0c3.svg";